// extracted by mini-css-extract-plugin
export default {"plans-container":"ProjectPlans_plans-container__LRSmw","plans-stack":"ProjectPlans_plans-stack__KBl+D","plans-stack-button-row":"ProjectPlans_plans-stack-button-row__oVWyw"};